import { cn } from '@lqa-frontend/ui-system';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';
import { useResolvedPortalContainer } from '../../hooks/use-portal-container';

function Popover({
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Root>) {
	return <PopoverPrimitive.Root data-slot="popover" {...props} />;
}

function PopoverTrigger({
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
	return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}

interface IPopoverContentProps extends React.ComponentProps<
	typeof PopoverPrimitive.Content
> {
	portalContainer?: HTMLElement | null;
}

function PopoverContent({
	className,
	align = 'center',
	sideOffset = 4,
	portalContainer,
	onCloseAutoFocus,
	...props
}: Readonly<IPopoverContentProps>) {
	const resolvedContainer = useResolvedPortalContainer(portalContainer);
	return (
		<PopoverPrimitive.Portal container={resolvedContainer}>
			<PopoverPrimitive.Content
				data-slot="popover-content"
				align={align}
				sideOffset={sideOffset}
				onCloseAutoFocus={(event) => {
					onCloseAutoFocus?.(event);
				}}
				className={cn(
					'bg-base-1 text-text-black data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-[100] w-72 origin-(--radix-popover-content-transform-origin) rounded-s border p-16 shadow-md outline-hidden',
					className
				)}
				{...props}
			/>
		</PopoverPrimitive.Portal>
	);
}

function PopoverAnchor({
	...props
}: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
	return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />;
}

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
export type { IPopoverContentProps };
